import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import EMP from "../../pages/common/EMP/EMP";

const RoleAwareEMP = ({ role }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const projectId = queryParams.get("projectId");

  const handleBack = () => {
    if (projectId) {
      navigate(`/${role}/projects/${projectId}`);
    } else {
      navigate(`/${role}/manage-projects`);
    }
  };

  const handleSaveSuccess = () => {
    if (projectId) {
      navigate(`/${role}/projects/${projectId}`);
    } else {
      navigate(`/${role}/manage-projects`);
    }
  };

  return (
    <EMP
      role={role}
      projectId={projectId}
      onBack={handleBack}
      onSaveSuccess={handleSaveSuccess}
    />
  );
};

export default RoleAwareEMP;
